/* Cellform — cart drawer, cart line updates and cart recommendations (Section Rendering API). */
(() => {
  if (window.CellformCartLoaded) return;
  window.CellformCartLoaded = true;
  const { Drawer, fetchJSON, announce } = window.Cellform;
  const theme = window.theme;

  function swapSections(sections) {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        const next = doc.getElementById('CartDrawer-Inner');
        const cur = document.getElementById('CartDrawer-Inner');
        if (next && cur) {
          const active = document.activeElement && document.activeElement.closest('[data-line]') ? document.activeElement.closest('[data-line]').dataset.line : null;
          cur.replaceWith(next);
          let focusEl = null;
          if (active) focusEl = next.querySelector(`[data-line="${active}"] input`);
          if (next.closest('.is-open')) window.Cellform.trapFocus(next, focusEl || next.querySelector('[data-drawer-close]'));
        }
      } else if (id === 'cart-icon-bubble') {
        const cur = document.getElementById('CartCount');
        const next = doc.querySelector('.shopify-section');
        if (cur && next) cur.innerHTML = next.innerHTML;
      } else {
        const cur = document.getElementById(`shopify-section-${id}`);
        const next = doc.getElementById(`shopify-section-${id}`);
        if (cur && next) cur.innerHTML = next.innerHTML;
      }
    });
  }

  async function refreshTotals() {
    try {
      const cart = await fetch(`${theme.routes.cart}.js`).then((r) => r.json());
      document.dispatchEvent(new CustomEvent('cart:totals', { detail: { total: cart.total_price, count: cart.item_count } }));
    } catch (e) { /* noop */ }
  }

  document.addEventListener('cart:updated', (e) => {
    swapSections(e.detail.sections);
    refreshTotals();
  });

  class CartDrawer extends Drawer {
    open(opener) {
      super.open(opener);
      const recs = this.querySelector('cart-recommendations');
      if (recs) recs.load();
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  class CartItems extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (e) => {
        const input = e.target.closest('input[data-line]');
        if (input) this.update(input.dataset.line, Number(input.value));
      });
      this.addEventListener('click', (e) => {
        const remove = e.target.closest('[data-remove-line]');
        if (!remove) return;
        e.preventDefault();
        this.update(remove.dataset.removeLine, 0);
      });
      const note = document.querySelector('[data-cart-note]');
      if (note && !note.dataset.bound) {
        note.dataset.bound = '1';
        note.addEventListener('input', window.Cellform.debounce(() => fetchJSON(`${theme.routes.cartUpdate}.js`, { note: note.value }), 500));
      }
    }
    sectionIds() {
      const ids = ['cart-drawer', 'cart-icon-bubble'];
      document.querySelectorAll('[data-cart-section]').forEach((el) => ids.push(el.dataset.cartSection));
      return ids;
    }
    async update(line, quantity) {
      const row = this.querySelector(`[data-line="${line}"]`);
      if (row) row.style.opacity = '.5';
      try {
        const res = await fetchJSON(`${theme.routes.cartChange}.js`, { line: Number(line), quantity, sections: this.sectionIds(), sections_url: window.location.pathname });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { sections: res.sections, source: 'change' } }));
        announce(theme.strings.cartUpdated);
        if (res.item_count === 0 && this.dataset.context === 'page') window.location.reload();
      } catch (err) {
        if (row) {
          row.style.opacity = '';
          const errEl = row.querySelector('.cart-item__error');
          if (errEl) { errEl.textContent = err.description || err.message || theme.strings.cartError; errEl.hidden = false; }
        }
      }
    }
  }
  if (!customElements.get('cart-items')) customElements.define('cart-items', CartItems);

  class CartRecommendations extends HTMLElement {
    connectedCallback() { if (this.closest('.is-open')) this.load(); }
    async load() {
      if (this.loaded || !this.dataset.url) return;
      this.loaded = true;
      try {
        const html = await fetch(this.dataset.url).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const recs = doc.querySelector('.cart-recs');
        if (recs) this.replaceChildren(...recs.children);
      } catch (e) { /* recommendations are optional */ }
    }
  }
  if (!customElements.get('cart-recommendations')) customElements.define('cart-recommendations', CartRecommendations);

  // Begin checkout analytics hook (Shopify also emits checkout_started automatically).
  document.addEventListener('submit', (e) => {
    if (e.submitter && e.submitter.name === 'checkout') window.Cellform.publish('begin_checkout', {});
  });
})();
